import dayjs from "dayjs";


export const getUrlString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

export const getUrlSearch = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let qIndex = window.location.href.lastIndexOf("?");
  var r = window.location.href.substr(qIndex+1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}


export const flatDeep = (arr) => {
  return arr.reduce((a, b) => {
    a = a.concat({path: b.path});
    if (b.children && b.children.length) {
      return a.concat(flatDeep(b.children));
    } else {
      return a;
    }
  }, []);
};

/*
* 地址展示过滤 根据省市县区返回需要显示的地址
* @param address 必要属性  province省  city市  district县区
* */
export const addressView = (address = {}) => {
  let total_address = address.province || "";
  total_address += address.province == address.city ? '' : (address.city || "");
  total_address += address.city == address.district ? '' : (address.district || "");
  return total_address + (address.address || "") + (address.street || "");
}

/*
* 地址展示过滤 根据省市县区返回需要显示的地址
* 组装标准地址对象
* */
export const packageAddress = (address = {}) => {
  return (({province, city, district, street, address, mapLat, mapLng}) => ({
    province,
    city,
    district,
    street,
    address,
    mapLat,
    mapLng
  }))(address);
}

/*
* 从源对象过滤出需要的键值对，返回新对象
*  @param origin
*  @param [key1,key2,key3]
*  @return newObj
* */
export const filterObj = (origin = {}, ...reset) => {
  return reset.reduce((newObj, key) => {
    newObj[key] = origin[key];
    return newObj
  }, {});
}


/*
* 格式化时间
*
* */
export const dateFormat = (date, format = "YYYY-MM-DD") => {
  if (!date) return "";
  return dayjs(date).format(format)
}


/*
* 移除url参数
*
* */
export const replaceUrl = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[0]);
  return null;
};

/**
 * 根据拼接的接口地址下载文件
 * @constructor
 */
export const downloadWithUrl = (url,fileName) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = () => {
    if (xhr.status === 200) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(xhr.response, fileName);
      } else {
        const link = document.createElement('a');
        const body = document.querySelector('body');
        link.href = window.URL.createObjectURL(xhr.response);
        link.download = fileName;
        // fix Firefox
        link.style.display = 'none';
        body.appendChild(link);
        link.click();
        body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }
    }
  };
  xhr.send();
}

/**
 * 返回文件大小显示
 * @param {number} size
 * @returns {string}
 * @constructor
 */
 export const FileSize = (bytes) => {
  let size = "";
  if (bytes < 1024) {
    //小于1KB，则转化成B
    size = Math.ceil(bytes) + " B";
  } else if (bytes < 1024 * 1024) {
    //小1MB，则转化成KB
    size = Math.ceil(bytes / 1024) + " K";
  } else if (bytes < 1024 * 1024 * 1024) {
    //小于1GB，则转化成MB
    size = Math.ceil(bytes / (1024 * 1024)) + " M";
  } else if (bytes < 1024 * 1024 * 1024 * 1024) {
    //其他转化成GB
    size = Math.ceil(bytes / (1024 * 1024 * 1024)) + " G";
  } else {
    size = Math.ceil(bytes / (1024 * 1024 * 1024 * 1024)) + " T";
  }
  return size;
  // let sizeStr =
};